import Swal from 'sweetalert2';
import { writable } from 'svelte/store';
import 'sweetalert2/dist/sweetalert2.css';

export let key = writable("");
export let disabledButton = writable(true);
export let username = writable("");
export let password = writable("");
export let logincode = writable("");
export let errorAlertMessage = writable("");

let guid = () => {
    let s4 = () => {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        //return id of format 'aaaaaaaa'-'aaaa'-'aaaa'-'aaaa'-'aaaaaaaaaaaa'
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

export async function InitForm() {
    let key_ = guid();
    key.set(key_);
}

export async function OnChangeLogin() {
    let key_ = "";
    let unsubscribe = key.subscribe(value => {
        key_ = value;
    });

    let username_ = "";
    let unsubscribe1 = username.subscribe(value => {
        username_ = value;
    });

    if (username_.length > 3) {
        data = {
            "key": key_,
            "type": "Telegram",
            "username": username_,
        }
        disabledButton.set(false);
        let url = "/accounts/login_init/";
        let response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(data),
        });

        if (response.status == 200) {
            if (response.ok) {
                let json = await response.json();
                if (!json["result"]) {
                    if (json["message"] != "") {
                        Swal.fire({
                            title: "Ошибка",
                            text: json["message"],
                            buttonsStyling: false,
                            confirmButtonClass: "btn btn-warning",
                            icon: "warning"
                        });
                    }
                    //Блокировка входа на указанное время
                    let time_block = json["time_block"];
                    disabledButton.set(true);
                    setTimeout(function() {
                        disabledButton.set(false);
                    }, time_block);
                }
                return json["result"];
            } else {
                errorAlertMessage.set("Ошибка ответа сервера. Повторите попытку позже.");
                return false;
            }
        } else if (response.status == 404) {
            errorAlertMessage.set("Сервер не доступен. Повторите попытку позже.");
            return false;
        }
    }
    return false;
}

export async function login(type) {
    let key_ = "";
    let unsubscribe = key.subscribe(value => {
        key_ = value;
    });

    let username_ = "";
    let unsubscribe1 = username.subscribe(value => {
        username_ = value;
    });

    let password_ = "";
    let unsubscribe2 = password.subscribe(value => {
        password_ = value;
    });

    let logincode_ = "";
    let unsubscribe3 = logincode.subscribe(value => {
        logincode_ = value;
    });

    let data = {}
    if (type == "Telegram") {
        if (username_.length > 0 && logincode_.length > 0) {
            data = {
                "type": "Telegram",
                "key": key_,
                "username": username_,
                "login_code": logincode_,
            }
        }
    } else {
        if (username_.length > 0 && password_.length > 0) {
            data = {
                "type": "ByPassword",
                "key": key_,
                "username": username_,
                "password": password_,
            }
        }
    }

    let url = "/accounts/login/";
    let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
    });

    if (response.status == 200) {
        if (response.ok) {
            let json = await response.json();
            if (json["result"]) {
                Swal.fire({
                    title: "Вы совершили успешный вход!",
                    text: "Спасибо, вход успешный",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-success",
                    icon: "success"
                }).then(function() { window.location.href = "/profile_journal/"; });
            } else {
                Swal.fire({
                    title: "Ошибка",
                    text: json["message"],
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-warning",
                    icon: "warning"
                });
            }
            return json["result"];
        } else {
            errorAlertMessage.set("Ошибка ответа сервера. Повторите попытку позже.");
            return false;
        }
    } else if (response.status == 404) {
        errorAlertMessage.set("Сервер не доступен. Повторите попытку позже.");
        return false;
    }
    return false;
}